<template>
    <div class="legal-status__container">
        <LegalTag
            v-for="(code, index) in legalStatus"
            :key="index"
            :isSimple="isSimple"
            :code="code"
            :currentLang="currentLang"
            :modeType="modeType"
        />
        <slot />
        <ElTooltip
            v-for="obj in legalMaps"
            :key="obj.id"
            placement="top"
            :visible-arrow="false"
            :open-delay="popperOpenDelay"
        >
            <div slot="content">{{ obj.label }}</div>
            <div class="legal-status__box">
                <a :href="obj.url" :target="openType" @click.stop="clickCall(obj.name, $event)">
                    <PtIcon :icon="obj.icon" />
                </a>
                <span class="legal-status__text" v-if="showText === true">{{ obj.label }}</span>
            </div>
        </ElTooltip>
    </div>
</template>

<script>
import legal from './legal';

export default legal;
</script>

<style lang="scss">
    .legal-status__container {
        a {
            color: inherit;
            margin: 0 3px;
        }
        .legal-status__box {
            display: inline-block;
            .patsnap-biz-icon {
                margin-top: -4px;
                fill: $status-success-primary;
                font-size:16px;
            }
        }
        .legal-status__text {
            margin-right: 8px;
            letter-spacing: 0.25px;
        }
    }
    /*组件样式覆盖*/
    /*组件样式覆盖*/
    /*组件样式覆盖*/
    .legal-status__container {
        .legal-tag {
            margin-right: 12px;
            vertical-align: middle;
            &:last-of-type {
                margin-right: 8px;
            }
        }
    }
</style>
